const PATH = '/macro/top';

function stringifyFilters (filters) {

    if (!filters) return null;
    if (filters && Object.keys(filters).length === 0) return null;
    return JSON.stringify(filters);
}

export default {
    async getTopTen() {

        return axios.get(`${PATH}`);
    },
    async getTopTenPro({filters, tradingTime, gOnly}) {

        filters = stringifyFilters(filters);
        let params = {tradingTime, gOnly};

        if (filters) params.filters = filters;
        return axios.get(`${PATH}ro`, {
            params,
        });
    }
}
